import React from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import ModalContainer from '../modal-container'
import CheckPinForm from './check-pin-form'
import { getModalLocation } from '../../lib/modal'
import NavLinkWithQuery from '../shared/nav-link-with-query'
import { MODALS } from '../../constants'
import { validatePin, dismissPin } from '../../actions'
import { getOnValidPin, getPinVisibility } from '../../lib/pin'
import styles from './check-pin.css'

/**
 * CheckPin modal validates the PIN when the user adds, edits, switch or deletes a profile.
 */
function CheckPin() {
  const location = useLocation()
  const dispatch = useDispatch()
  const visibility = useSelector(getPinVisibility)
  const onValidPinFromState = useSelector(getOnValidPin)
  const validate = () => dispatch(validatePin())
  const dismiss = () => dispatch(dismissPin())

  const onValidPin = (pin) => {
    validate()

    if (onValidPinFromState) {
      onValidPinFromState(pin)
    }
  }

  if (!visibility) return null

  return (
    <ModalContainer
      onRequestClose={dismiss}
    >
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h1 className={styles.title}>Enter PIN</h1>
          <span className={styles.subheader}>
            Parental controls are set. Please enter the 4-digit account PIN to access your profile.
          </span>
          <div className={styles.formWrapper}>
            <CheckPinForm
              onValidPin={onValidPin}
              onCancel={dismiss}
            />
          </div>

          <NavLinkWithQuery
            to={getModalLocation(location, MODALS.qsParams.pinForgotten)}
            onClick={dismiss}
          >
            Forgot your PIN?
          </NavLinkWithQuery>
        </div>
      </div>
    </ModalContainer>
  )
}

export default CheckPin
